import './assets/blk-loading.css';
import './assets/global.css';
import 'react-placeholder/lib/reactPlaceholder.css';
import 'react-quill-new/dist/quill.snow.css';

import { App, ConfigProvider } from 'antd';
import ptBR from 'antd/locale/pt_BR';

import Clarity from '@microsoft/clarity';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AuthSessionSync from 'components/Shared/AuthSessionSync';
import Routes from 'Routes';
import { CLARITY_ID, ENV } from 'settings';
import { antdTheme } from 'styles/antd';

import GoogleMapsLib from './services/GoogleMapsLib';

declare global {
  interface Window {
    google?: any;
  }
}

const queryClient = new QueryClient();

const AppRoot = () => {
  if (ENV === 'production') {
    Clarity.init(CLARITY_ID);
  }

  console.log('(Front) Version Number: 1217 / Branch: master / Commit: df190c1dae');

  return (
    <ConfigProvider theme={antdTheme} locale={ptBR}>
      <QueryClientProvider client={queryClient}>
        <AuthSessionSync />
        <App notification={{ placement: 'topRight', duration: 6 }}>
          <GoogleMapsLib />
          <Routes />
          <ReactQueryDevtools initialIsOpen={false} buttonPosition='bottom-left' />
        </App>
      </QueryClientProvider>
    </ConfigProvider>
  );
};

export default AppRoot;
